import React from 'react'
import '../../theme/icons'
import ErrorBoundary from '../ErrorBoundary'
import Footer from '../Footer'
import Nav from '../Nav'
import { Box } from '../UI'

const Layout = ({ location, children }) => {
  return (
    <React.Fragment>
      <Nav />
      {/* <Popup
        heading="The Rizzolo Guitars book is out now!"
        text={`A photographic book of forty guitars selected from forty years of
        guitarmaking.`}
        buttonLabel="Get the book"
        imgSrc="/rizzolo-book--cover.png"
        to="/product/rizzolo-book"
        popupId="rizzolo-book-202009"
        hiddenRoutes={['/shop', '/product/rizzolo-book']}
        // campaignStart="2020-09-28"
        // campaignEnd="2020-12-31"
      /> */}
      <Box
        as="main"
        id="site-top"
        mt={'navBarHeight' /* the nav height offset */}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </Box>
      <Footer />
    </React.Fragment>
  )
}

Layout.propTypes = {}

export default Layout
